import { render } from "./PetFooter.vue?vue&type=template&id=6d9daf1a&scoped=true"
import script from "./PetFooter.vue?vue&type=script&lang=js"
export * from "./PetFooter.vue?vue&type=script&lang=js"

import "./PetFooter.vue?vue&type=style&index=0&id=6d9daf1a&scoped=true&lang=sass"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9daf1a"]])

export default __exports__